import { Card } from '../ui/card';
import { Award, Eye, Shield, TrendingUp } from 'lucide-react';

export const AchievementsCard = ({ selectedCount, bubbleBreaks }) => (
  <Card className="p-6 sm:p-8">
    <div className="flex items-center gap-3 mb-4">
      <Award className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-600" />
      <h2 className="text-xl sm:text-2xl font-serif font-bold">Your Achievements</h2>
    </div>

    <div className="space-y-4">
      <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
          <Eye className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-sm sm:text-base">Perspective Seeker</h3>
          <p className="text-xs sm:text-sm text-gray-600">Read stories from {selectedCount} different sources</p>
        </div>
      </div>

      <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
          <Shield className="w-6 h-6 text-green-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-sm sm:text-base">Bubble Breaker</h3>
          <p className="text-xs sm:text-sm text-gray-600">Escaped your filter bubble {bubbleBreaks || 0} times</p>
        </div>
      </div>

      <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
          <TrendingUp className="w-6 h-6 text-purple-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-sm sm:text-base">Media Literate</h3>
          <p className="text-xs sm:text-sm text-gray-600">Understanding news bias and framing</p>
        </div>
      </div>
    </div>
  </Card>
);
